<template>
    <div class="alert_bg" @click.stop.prevent="closeAlert()">
        <div class="alert_ct">
            <span class="alert_tx alert_tx_pad"> {{ textProp }} </span>

            <div class="alert_bt_ct">
                <div v-if="confirmProp" class="div_botao" @click.stop.prevent="closeAlert()">
                    <span class="alert_tx" style="color: white;">{{ getInterText(0) }}</span>
                </div>
                <div v-if="confirmProp" class="div_botao" @click.stop.prevent="actionAlert()">
                    <span class="alert_tx" style="color: white;">{{ confirmTextProp }}</span>
                </div>
                <div v-else class="div_botao" @click.stop.prevent="closeAlert()">
                    <span class="alert_tx" style="color: white;">Ok</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Alert",
        props: {
            textProp: {
                type: String,
                default: 'Empty'
            },
            confirmTextProp: {
                type: String,
                required: false,
                default: 'Ok'
            },
            confirmProp: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                inter_pt: [
                    'Cancelar'
                ],
                inter_en: [
                    'Cancel'
                ],
                inter_es: [
                    'Cancelar'
                ]
            }
        },
        methods: {
            getInterText(index) {
                // console.log('getInterText::', index)
                switch (this.user.idioma) {
                    case 1:
                        return this.inter_en[index];
                    case 2:
                        return this.inter_es[index];
                    default:
                        return this.inter_pt[index];
                }
            },
            closeAlert() {
                console.log('closeAlert: ')
                this.$emit('emit-close')
            },
            actionAlert() {
                console.log('actionAlert:confirmProp: ', this.confirmProp)
                this.$emit('emit-action')
            }
        },
        created () {
            if (localStorage.getItem('user')) {
                this.user = JSON.parse(localStorage.getItem('user'));
            }
        }
    }
</script>

<style scoped>
    .alert_bg {
        z-index: 1000000;
        width: 100vw;
        height: 100vh;
        background-color: #33333399;
        top: 0;
        display: flex;
        position: fixed;
        justify-content: center;
        align-items: center;
    }

    .alert_ct {
        width: 90%;
        background-color: white;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-radius: 20px;
        padding-top: 3vh;
        padding-bottom: 3vh;
        -webkit-box-shadow: 0 0 3px #AAAAAADD;
        -moz-box-shadow: 0 0 3px  #AAAAAADD;
        box-shadow: 0 0 3px #AAAAAADD;
    }

    .alert_bt_ct {
        margin-top: 2vh;
        display: flex;
        justify-content: center;
        width: 80%;
    }

    .alert_tx_pad {
        padding-right: 10%;
        padding-left: 10%;
    }

    .alert_tx {
        font-size: 2vh;
        font-weight: bold;
        line-height: 3vh;
        color: var(--bg-blue);
        font-style: normal;
        text-align: center;
        display: flex;
    }
    .div_botao {
        display: flex;
        align-items: center;
        padding: 0.5vh;
        line-height: 4vh;
        min-width: 20%;
        padding-right: 3vw !important;
        padding-left: 3vw !important;
        margin-right: 2.5%;
        margin-left: 2.5%;
        display: flex;
        color: white;
        background-color: var(--bg-blue);
        -webkit-border-radius: 7px;
        -moz-border-radius: 7px;
        border-radius: 7px;
        border-width: 1px;
        border-style: solid;
        border-color: var(--bg-blue);
        justify-content: center;
        margin-top: 2vh;
        cursor: pointer;
        /*background-color: red;*/
    }
    @media screen and (max-width: 999px) {
        .alert_ct {
            width: 90%;
        }
    }
    @media screen and (min-width: 1000px) {
        .alert_ct {
            width: 60%;
        }
    }
    @media screen and (min-width: 1400px) {
        .alert_ct {
            width: 50%;
        }
    }
    @media screen and (min-width: 1600px) {
        .alert_ct {
            width: 40%;
        }
    }
    @media screen and (min-width: 1900px) {
        .alert_ct {
            width: 30%;
        }
    }
    @media screen and (min-width: 2200px) {
        .alert_ct {
            width: 20%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/templates/Alert.vue